import { render, staticRenderFns } from "./StickyNavTop.vue?vue&type=template&id=ffc03048&scoped=true&"
import script from "./StickyNavTop.vue?vue&type=script&lang=js&"
export * from "./StickyNavTop.vue?vue&type=script&lang=js&"
import style0 from "./StickyNavTop.vue?vue&type=style&index=0&id=ffc03048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc03048",
  null
  
)

export default component.exports